import PropTypes from 'prop-types'
import React from 'react'

import UsDollarsNoticeContainer from '../usDollarsNotice/usDollarsNoticeContainer'

const Magnifier = ({ item, width, height, children }) => {
  return (
    <div className="magnifier" style={{ width }}>
      <div className="size-limiter" style={{ height }}>
        {children}
      </div>
      <strong>{item.name}</strong>
      <div className="info">
        <div className="author-category">
          by <span className="author">{item.author_username}</span>
        </div>
        {item.ui.price ? (
          <div className="price">
            <span className="cost">
              <sup>$</sup>
              {item.ui.price}
            </span>
            {item.ui.pricePeriod && (
              <span className="price-period">/{item.ui.pricePeriod}*</span>
            )}
          </div>
        ) : null}
      </div>
      <div className="footer">
        <span className="category">{item.ui.formattedClassification}</span>
        <UsDollarsNoticeContainer styleClassName="gst-notice" />
      </div>
    </div>
  )
}

Magnifier.propTypes = {
  item: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number
}

export default Magnifier



// WEBPACK FOOTER //
// ./client/components/magnifier/magnifier.js